<div class="toolbar-popover" [attr.data-id]="popoverDataId">
  <div class="toolbar-popover__title" [attr.data-id]="popoverDataId + '-title'">
    <span class="font-bold text-surface-800">
      {{title}}
    </span>
  </div>
  <div class="toolbar-popover__content" [attr.data-id]="popoverDataId + '-content'">
    <ng-content />
  </div>
</div>